<template>
  <div>
    <CollectionView :endpoint="utilities.path('communities/@/modules/allowlist/applications', communityId)" v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("applications") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("creator") }}</div>
                <div class="table-header-cell">{{ translate("status") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("replied_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <PlayerView v-if="item.creator" :player="item.creator"/>
                  </div>
                  <div class="table-column" :class="{ 'text-danger': item.status.id === 3, 'text-success': item.status.id === 2, 'text-info': item.status.id === 1 }">{{ item.status.name }}</div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">{{ item.repliedAt ? utilities.formatDatetime(item.repliedAt) : "" }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="viewId = item.id">
                        <i class="fas fa-eye"></i>
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView :active="viewId !== undefined" @update:active="viewId = undefined" size="large">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ translate("allowlist.application") }}</h3>
          <ModalCloseButtonView @click="viewId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <AllowlistApplicationView :application-id="viewId" @reply="viewId = undefined; reload = true" @delete="viewId = undefined; reload = true"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import AllowlistApplicationView from "@/systems/modules/allowlist/AllowlistApplicationView.vue";
import {ButtonView, CollectionView, utilities, ModalView, ModalCloseButtonView} from "@/niftybit";
import PlayerView from "@/components/other/PlayerView.vue";
import {ref, watch} from "vue";

const props = defineProps({
  communityId: String,
  playerId: String
});

const reload = ref(false);

const viewId = utilities.routeQueryParam("viewId");

watch(() => props.playerId, () => {
  reload.value = true
});

</script>
